import React, { useEffect, useState } from "react";
import BaseApi from "../../Http/BaseApi";

export default function PayrollPortal() {
  const [urlParams, setUrlParams] = useState({});
  const [loading, setLoading] = useState(false);

  const openPayrollPortal = async () => {
    setLoading(true);
    try {
      const user = JSON.parse(localStorage.getItem("userData"));
      const res = await BaseApi("staff").get("handoff-token");
      const token = res.data?.token;
      const staff_id = res.data?.staff_id || user?.user?.id;

      var form = document.createElement("form");
      form.setAttribute("method", "post");
      form.setAttribute("action", "https://payroll.dibru.work/loginById");
      var hiddenField = document.createElement("input");
      hiddenField.setAttribute("type", "hidden");
      hiddenField.setAttribute("name", "token");
      hiddenField.setAttribute("value", token);
      var hiddenField2 = document.createElement("input");
      hiddenField2.setAttribute("type", "hidden");
      hiddenField2.setAttribute("name", "staff_id");
      hiddenField2.setAttribute("value", staff_id);
      form.appendChild(hiddenField);
      form.appendChild(hiddenField2);
      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);
    } catch (_) {
      alert("Could not open payroll portal. Please login again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const error = params.get("error");
    setUrlParams({ error });
  }, []);

  return (
    <div className='m-10 text-center'>
      <p className='p-10 m-10 text-red-600'>{urlParams?.error}</p>
      <button
        onClick={openPayrollPortal}
        disabled={loading}
        className='px-4 py-2 font-bold text-white bg-blue-500 rounded hover:bg-blue-700'
      >
        {loading ? "Opening..." : "Open Payroll Portal"}
      </button>
    </div>
  );
}
